/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { PagedResponseOfTagListEntryFromJSON, TagRequestToJSON, TagResponseFromJSON, } from '../models';
/**
 *
 */
var TagRestControllerApi = /** @class */ (function (_super) {
    __extends(TagRestControllerApi, _super);
    function TagRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new tag  \'Permission#CREATE_TAG\' is required to access to this endpoint
     * Create a new tag  \'Permission#CREATE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.createTagRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.tagRequest === null || requestParameters.tagRequest === undefined) {
                            throw new runtime.RequiredError('tagRequest', 'Required parameter requestParameters.tagRequest was null or undefined when calling createTag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/tags",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: TagRequestToJSON(requestParameters.tagRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return TagResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new tag  \'Permission#CREATE_TAG\' is required to access to this endpoint
     * Create a new tag  \'Permission#CREATE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.createTag = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createTagRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete tag  \'Permission#DELETE_TAG\' is required to access to this endpoint
     * Delete tag  \'Permission#DELETE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.deleteTagRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
                            throw new runtime.RequiredError('tagId', 'Required parameter requestParameters.tagId was null or undefined when calling deleteTag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/tags/{tagId}".replace("{".concat("tagId", "}"), encodeURIComponent(String(requestParameters.tagId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete tag  \'Permission#DELETE_TAG\' is required to access to this endpoint
     * Delete tag  \'Permission#DELETE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.deleteTag = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteTagRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get tag details  \'Permission#READ_TAG\' is required to access to this endpoint
     * Get tag details  \'Permission#READ_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.getTagRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
                            throw new runtime.RequiredError('tagId', 'Required parameter requestParameters.tagId was null or undefined when calling getTag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/tags/{tagId}".replace("{".concat("tagId", "}"), encodeURIComponent(String(requestParameters.tagId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return TagResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get tag details  \'Permission#READ_TAG\' is required to access to this endpoint
     * Get tag details  \'Permission#READ_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.getTag = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTagRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List tags using pagination  \'Permission#READ_TAG\' is required to access to this endpoint
     * List tags using pagination  \'Permission#READ_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.listTagsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/tags",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfTagListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List tags using pagination  \'Permission#READ_TAG\' is required to access to this endpoint
     * List tags using pagination  \'Permission#READ_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.listTags = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listTagsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update tag  \'Permission#UPDATE_TAG\' is required to access to this endpoint
     * Update tag  \'Permission#UPDATE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.updateTagRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
                            throw new runtime.RequiredError('tagId', 'Required parameter requestParameters.tagId was null or undefined when calling updateTag.');
                        }
                        if (requestParameters.tagRequest === null || requestParameters.tagRequest === undefined) {
                            throw new runtime.RequiredError('tagRequest', 'Required parameter requestParameters.tagRequest was null or undefined when calling updateTag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/tags/{tagId}".replace("{".concat("tagId", "}"), encodeURIComponent(String(requestParameters.tagId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: TagRequestToJSON(requestParameters.tagRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return TagResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update tag  \'Permission#UPDATE_TAG\' is required to access to this endpoint
     * Update tag  \'Permission#UPDATE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.updateTag = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateTagRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TagRestControllerApi;
}(runtime.BaseAPI));
export { TagRestControllerApi };
